import React, { useEffect, useState } from 'react';
import Prism from 'prismjs'; // Import Prism.js
import 'prismjs/themes/prism.css'; // Import a Prism theme
import capitalize from 'lodash/capitalize';
import { Button, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { MONGO_COMMANDS, DYNAMIC_TABLE, LIST, getApiPath, ADD_UPDATE } from '../../api/ApiConst'; 
import apiCaller from "../../api/ApiCaller";
import textUtils from '../common/utilities/TextUtils';
import './print.css';

const CommandAddUpdate = (props) => {
    const [allTables, setAllTables] = useState([]);
    const [allTableOptions, setAllTableOptions] = useState([]);
    const [commandObj, setCommandObj] = useState({
        id: "",
        name: "",
        value: "",
        type: "",
        collectionFrom: "",
    });
    const [commandTypeKeyValue, setCommandTypeKeyValue] = useState("");

    const commandTypeOptions = [
        { label: "Aggregation", value: "AGGREGATION" },
        { label: "Find", value: "FIND" },
    ];

    const toggle = () => {
        props.close();
    };

    const previewJavaScript = () => {
        const elem = document.getElementById('previewJson');
        if (!elem) return;

        const valueProp = commandObj?.value || '';
        const escapedJs = valueProp;

        // Use Prism.js to highlight the code
        elem.innerHTML = `<code class="language-javascript">${Prism.highlight(
            escapedJs,
            Prism.languages.javascript,
            'javascript'
        )}</code>`;
    };

    useEffect(() => {
        setAllTableOptions(allTables.map(table => ({ label: table?.name, value: table?.id })));
    }, [allTables]);

    useEffect(() => {
        if (props.object != null) {
            setCommandObj(props.object);
            if (props.object.type !== "") {
                setCommandTypeKeyValue({
                    label: capitalize(props.object.type),
                    value: props.object.type,
                });
            } else {
                setCommandTypeKeyValue("");
            }
        }
        previewJavaScript();
    }, [props.object]);

    useEffect(() => {
        previewJavaScript();
    }, [commandObj?.value]);

    useEffect(() => {
        apiCaller.callPostApi(getApiPath(DYNAMIC_TABLE, LIST), {
            page: 0,
            size: 200,
            searchFilters: [],
            sortRules: [],
        }, {}, (response) => {
            setAllTables(response?.data);
        }, (error) => {
            console.error(error);
        });
    }, []);

    const handleTextChange = (e, type) => {
        if (type === "text" || type === "textarea") {
            setCommandObj(prev => ({ ...prev, [e.target.id]: e.target.value }));
        } else if (type === "select") {
            setCommandTypeKeyValue(e);
            setCommandObj(prev => ({ ...prev, type: e.value }));
        }
    };

    const handleCreateUpdateCommand = () => {
        let requestObj = commandObj;
        if ((textUtils.isEmpty(requestObj.name, "Name", true)) ||
            textUtils.isEmpty(requestObj.type, "Type", true) ||
            (textUtils.isEmpty(requestObj.value, "Command Value", true)) ||
            (textUtils.isEmpty(requestObj.collectionFrom, "Collection From", true))
        ) {
            return false;
        }
        let url = getApiPath(MONGO_COMMANDS, ADD_UPDATE);
        apiCaller.callPostApi(url, requestObj, {}, (response) => {
            toast.success(`Command ${commandObj.id ? "Update" : "Created"} Successfully`);
            toggle();
            props.successCallBack();
        }, (error) => {
            console.error(error);
        });
    };

    return (
        <>
            <Modal size="xl" show={props.show} onHide={toggle} scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>Create Command</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-6">
                                {/* Restored Name Field */}
                                <div className="form-group row mb-3">
                                    <div className="col-lg-12">
                                        <label>Name *</label>
                                        <input
                                            type="text"
                                            placeholder="Command Name"
                                            className="form-control"
                                            autoComplete="off"
                                            name="name"
                                            id="name"
                                            value={commandObj.name}
                                            onChange={(e) => handleTextChange(e, e.target.type)}
                                        />
                                    </div>
                                </div>
                                {/* Type Dropdown */}
                                <div className="form-group row mb-3">
                                    <div className="col-lg-12">
                                        <label>Type *</label>
                                        <Select
                                            options={commandTypeOptions}
                                            placeholder="Select Type..."
                                            value={commandTypeKeyValue}
                                            id="type"
                                            onChange={(e) => handleTextChange(e, "select")}
                                            className="react-select-container"
                                        />
                                    </div>
                                </div>
                                {/* Collection From Field */}
                                <div className="form-group row mb-3">
                                    <div className="col-lg-12">
                                        <label>Collection From *</label>
                                        <Select
                                            options={allTableOptions}
                                            placeholder="Select Collection From..."
                                            value={commandObj.collectionFrom ?
                                                { label: allTableOptions.find((option) => option.value === commandObj.collectionFrom)?.label, value: commandObj.collectionFrom }
                                                : ""}
                                            id="collectionFrom"
                                            onChange={(e) => setCommandObj(prev => ({ ...prev, collectionFrom: e.value }))}
                                            className="react-select-container"
                                        />
                                    </div>
                                </div>
                                {/* Value Field */}
                                <div className="form-group row mb-3">
                                    <div className="col-lg-12">
                                        <label>Value *</label>
                                        <textarea
                                            className="form-control"
                                            id="value"
                                            name="value"
                                            cols={60}
                                            rows={12}
                                            placeholder="Enter JavaScript code"
                                            value={commandObj.value}
                                            onChange={(e) => handleTextChange(e, e.target.type)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <h5>PREVIEW</h5>
                                <div className="json-container p-2">
                                    <pre id="previewJson"></pre>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCreateUpdateCommand}>
                        {commandObj.id ? "Update" : "Create"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default CommandAddUpdate;
